import { IonButton, IonContent, IonPage } from '@ionic/react';
import { useAuth } from '../../lib/auth/AuthProvider.js';

// TrialExpiredPage (T-019). Mostrata da AuthGate quando il JWT claim
// `trial_active === false`. Sostituisce l'intera app (hard block totale):
// niente tab, niente accesso ai dati. Unico modo di "uscire" è contattare
// l'owner per attivare l'abbonamento o cambiare account.
//
// L'owner della piattaforma non vede mai questa pagina: il JWT hook gli
// forza `trial_active=true` indipendentemente dallo status del tenant.
export function TrialExpiredPage(): JSX.Element {
  const { signOut, profile } = useAuth();

  // Messaggio WhatsApp pre-compilato col nome del profilo, quando disponibile.
  // Numero +39 348 638 2343 (lo stesso usato dal funnel su trackeat.eu).
  const greeting = profile?.full_name ? `Ciao, sono ${profile.full_name}.` : 'Ciao,';
  const waText = encodeURIComponent(
    `${greeting} Il mio periodo di prova TrackEAT è terminato e vorrei attivare l'abbonamento per continuare a usarla.`,
  );
  const waUrl = `https://wa.me/393486382343?text=${waText}`;

  async function handleSignOut(): Promise<void> {
    try {
      await signOut();
    } catch {
      // best-effort: anche se la chiamata fallisce, la sessione locale
      // verrà comunque ripulita al prossimo refresh.
    }
  }

  return (
    <IonPage>
      <IonContent
        style={{ '--background': 'linear-gradient(180deg, #fef3c7 0%, #fef9c3 100%)' } as React.CSSProperties}
      >
        <div
          className="te-auth-shell"
          style={{
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '32px 24px',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div
              style={{
                width: 96,
                height: 96,
                borderRadius: 32,
                background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                color: '#fff',
                fontSize: 52,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 14px 32px rgba(217, 119, 6, 0.3)',
                marginBottom: 24,
              }}
            >
              ⏱
            </div>
            <h1
              style={{
                margin: '0 0 12px',
                fontSize: 26,
                fontWeight: 700,
                color: '#0f172a',
                letterSpacing: '-0.01em',
              }}
            >
              Periodo di prova terminato
            </h1>
            <p style={{ margin: 0, fontSize: 15, color: '#475569', lineHeight: 1.55 }}>
              Sono volati i tuoi 10 giorni di prova di <strong>TrackEAT</strong>.
              <br />
              Speriamo ti sia stata utile e che vorrai continuare con noi.
            </p>
          </div>

          <div
            style={{
              background: '#ffffff',
              borderRadius: 16,
              padding: 18,
              marginBottom: 20,
              boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
              border: '1px solid #fde68a',
            }}
          >
            <p style={{ margin: 0, fontSize: 14, color: '#334155', lineHeight: 1.55 }}>
              Per riattivare l'app, scrivici un messaggio su WhatsApp:
              attiviamo il tuo abbonamento e i tuoi dati tornano subito
              disponibili — non hai perso nulla, tutto è al sicuro nel
              database.
            </p>
          </div>

          <IonButton
            expand="block"
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={
              {
                '--background': '#25d366',
                '--background-hover': '#1ebe5b',
                '--background-activated': '#1ebe5b',
                '--color': '#ffffff',
                '--border-radius': '14px',
                height: 56,
                fontSize: 16,
                fontWeight: 700,
                marginBottom: 12,
              } as React.CSSProperties
            }
          >
            Sentiamoci su WhatsApp
          </IonButton>

          <IonButton
            expand="block"
            fill="clear"
            onClick={handleSignOut}
            style={
              {
                '--color': '#64748b',
                '--border-radius': '14px',
                height: 48,
                fontSize: 14,
                fontWeight: 500,
              } as React.CSSProperties
            }
          >
            Esci e cambia account
          </IonButton>

          {profile?.email && (
            <p
              style={{
                margin: '20px 0 0',
                textAlign: 'center',
                fontSize: 12,
                color: '#94a3b8',
              }}
            >
              Account: {profile.email}
            </p>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
}
